import {connect} from 'react-redux';
import ShareModal from '../components/share-modal/share-modal.jsx';
import {
    setShareSavedInfo,
    clearShareSavedInfo,
    setSaveTab
} from '../reducers/project-state';
import {openShareModal} from '../reducers/modals';

const mapStateToProps = state => ({
    reduxProjectId: state.scratchGui.projectState.projectId,
    reduxProjectTitle: state.scratchGui.projectTitle,
    vm: state.scratchGui.vm
});

const mapDispatchToProps = dispatch => ({
    setShareSavedInfo: (savedTitle, savedDesc, savedTab) => {
        dispatch(setShareSavedInfo(savedTitle, savedDesc));
        dispatch(setSaveTab(savedTab));
    },
    clearShareSavedInfo: () => {
        dispatch(clearShareSavedInfo());
    },
    setSaveTab: (tab) => {
        dispatch(setSaveTab(tab));
    },
    // onReopenGuiShareModal: () => {
    //     dispatch(openShareModal());
    // }
});

export default connect(mapStateToProps, mapDispatchToProps)(ShareModal);
